<template>
  <v-card>
    <v-toolbar flat dark color="primary">
      <v-toolbar-title>Add New Bill</v-toolbar-title>
    </v-toolbar>
    <v-card-title primary-title>
      <v-layout wrap>
        <v-flex xs3 class="title">Customer:</v-flex>
        <v-flex xs9 class="subtitle-1">{{ company }}</v-flex>
        <v-flex xs3 class="title">Funder:</v-flex>
        <v-flex xs9 class="subtitle-1">{{ funder }}</v-flex>
        <v-flex xs3 class="title">CFX ENT:</v-flex>
        <v-flex xs9 class="subtitle-1">{{ cfx }}</v-flex>
        <v-flex xs12 class="pt-3">
          <v-divider></v-divider>
        </v-flex>
      </v-layout>
    </v-card-title>
    <v-card-text>
      <v-container grid-list-md>
        <v-layout wrap>
          <v-flex xs12>
            <v-text-field label="Registered Company to Bill" v-model="bill.registered_company_to_bill" />
          </v-flex>
          <v-flex xs12 sm6>
            <v-select :items="typesOfFee" v-model="bill.type_of_fee" label="Type of Fee"></v-select>
          </v-flex>
          <v-flex xs12 sm6>
            <select-bill-type :billId="null" :billType="bill.type" :label="'Bill Type'" @changed="childTypeChanged" />
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field label="Drawdown amount" v-model="bill.drawdown"></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field label="Fee" v-model="bill.fee"></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <bill-date-picker
              :billDate="bill.bill_date"
              :billId="null"
              :dateColumn="'bill_date'"
              :label="'Bill Date'"
              @changed="childDateChanged"
            />
          </v-flex>
          <v-flex xs12 sm6>
            <bill-date-picker
              :billDate="bill.received_date"
              :billId="null"
              :dateColumn="'received_date'"
              :label="'Date Received/Paid'"
              @changed="childDateChanged"
            />
          </v-flex>
        </v-layout>
        <v-layout wrap v-if="showReferralCredit">
          <v-flex xs12>
            <v-divider></v-divider>
          </v-flex>
          <v-flex xs12>
            <h4>Referral Credit</h4>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field label="Referral Credit Fee" v-model="referral_credit.fee"></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <bill-date-picker
              :billDate="referral_credit.bill_date"
              :billId="null"
              :dateColumn="'referral_credit.bill_date'"
              :label="'Referral Bill Date'"
              @changed="childReferralDateChanged"
            />
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12>
            <v-divider></v-divider>
            <v-textarea label="Comments" v-model="bill.comments" />
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text @click="close" :disabled="isSaving">Close</v-btn>
      <v-btn color="accent" @click="save" :loading="isSaving">Save</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex';
import _ from 'lodash';
import SelectBillType from '../Widgets/SelectBillType';
import BillDatePicker from '../Widgets/BillDatePicker';
import moment from 'moment';

const DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';

export default {
  name: 'add-bill-form',
  components: {
    SelectBillType,
    BillDatePicker
  },
  props: ['enquiry', 'dialog', 'alreadyBilled'],
  data: () => ({
    isSaving: false,
    company: '',
    cfx: '',
    funder: '',
    referralCreditPaid: false,
    referrerType: null,
    bill: {
      enquiry_id: null,
      registered_company_to_bill: null,
      type_of_fee: null,
      type: '',
      drawdown: 0,
      fee: 0,
      bill_date: moment().format(DATE_FORMAT),
      received_date: null,
      comments: null
    },
    referral_credit: {
      enquiry_id: null,
      registered_company_to_bill: null,
      type: 'referral_credit',
      fee: 0,
      bill_date: moment().format(DATE_FORMAT)
    },
    typesOfFee: ['Initial Fee', 'Ongoing Facility Fee']
  }),
  computed: {
    showReferralCredit() {
      return (
        this.referralCreditPaid === true &&
        this.bill.type === 'invoice' &&
        this.referrerType !== 'bank' &&
        this.referrerType !== null
      );
    }
  },
  methods: {
    ...mapActions(['addBill', 'addNotification']),
    childTypeChanged(type) {
      this.bill.type = type;
    },
    childDateChanged(date, column) {
      this.bill[column] = date;
    },
    childReferralDateChanged(date) {
      this.referral_credit.bill_date = date;
    },
    close() {
      this.$emit('changed', false);
    },
    async save() {
      this.isSaving = true;
      this.bill.received_date =
        this.bill.received_date !== null ? moment(this.bill.received_date).format(DATE_FORMAT) : null;

      try {
        await this.addBill(this.bill);

        if (this.showReferralCredit && this.referral_credit.fee > 0) {
          await this.addBill(this.referral_credit);
        }

        this.addNotification({
          text: `Bill added`
        });
      } catch (error) {
        this.addNotification({
          text: `BILL NOT ADDED: ${error.response.data.Error}`
        });
      }

      this.isSaving = false;
      this.$emit('changed', true);
    },
    setVariables(enquiry) {
      const registeredCompanyToBill =
        enquiry.product.registered_company_name || enquiry.product.provider.registered_company_name || null;

      this.bill = {
        enquiry_id: enquiry.id,
        registered_company_to_bill: registeredCompanyToBill,
        type_of_fee: null,
        type: '',
        drawdown: 0,
        fee: enquiry.expected_fee,
        bill_date: moment().format(DATE_FORMAT),
        received_date: null
      };

      this.referral_credit = {
        enquiry_id: enquiry.id,
        registered_company_to_bill: registeredCompanyToBill,
        type: 'referral_credit',
        fee: 0,
        bill_date: moment().format(DATE_FORMAT)
      };

      this.referralCreditPaid = enquiry.customer.referrer.referral_credit_paid;
      this.referrerType = enquiry.customer.referrer ? enquiry.customer.referrer.type : null;
      this.company = enquiry.customer.name.platform;
      this.funder = enquiry.product.name;
      this.cfx = enquiry.product.provider.job_code;
    }
  },
  mounted() {
    if (!_.isUndefined(this.enquiry.id)) {
      this.setVariables(this.enquiry);
    }
  },
  watch: {
    enquiry(enquiry) {
      this.setVariables(enquiry);
    },
    'bill.fee': function(newVal) {
      const referrerCommission = this.enquiry.customer.referrer.referral_commission_percentage;
      if (newVal && referrerCommission) {
        this.referral_credit.fee = (newVal / 100) * referrerCommission;
      }
    }
  }
};
</script>

<style scoped>
.v-application .subtitle-1 {
  line-height: 2rem;
}
</style>
